import React from 'react';
import { FormattedMessage } from 'react-intl';

import ActionModal from 'components/Shared/ActionModal/ActionModal';

export interface Props {
  hide: () => void;
  onContinue: () => void;
}

const SchedulePayCancelModal: React.FC<Props> = ({ hide, onContinue }) => {
  return (
    <ActionModal
      hide={hide}
      onContinue={onContinue}
      headerIntl={{
        id: 'SCHEDULE_PAY_CANCEL_MODAL_HEADER',
        defaultMessage: 'Cancel this scheduled payment?',
      }}
      continueIntl={{
        id: 'SCHEDULE_PAY_CANCEL_MODAL_UNSCHEDULE_BTN',
        defaultMessage: 'Yes, cancel it',
      }}
      cancelIntl={{
        id: 'SCHEDULE_PAY_CANCEL_MODAL_BACK_BUTTON',
        defaultMessage: 'No, keep scheduled payment',
      }}
      hideOnContinueFinish={false}
      width="208px"
    >
      <div>
        <FormattedMessage
          id="SCHEDULE_PAY_CANCEL_MODAL_BODY"
          defaultMessage="If you cancel, you can sign in again to pay or reschedule it."
        />
      </div>
    </ActionModal>
  );
};

export default SchedulePayCancelModal;
